import React, { lazy, Suspense } from 'react'
import { Route, Switch, BrowserRouter as ReactRouter, Redirect } from 'react-router-dom'
import { useAuth } from '../../lib/hooks'
import Spinner from '../Spinner'
import PrivateRoute from './PrivateRoute'
import DemandeExpress from '../DemandeExpress'
import DemandeDrawer from '../DemandeDrawer'
import DemandeDeRappel from '../DemandeDeRappel'
import Layout from '../Layout'
const Notes = lazy(() => import('../../pages/notes'))
const Legacy = lazy(() => import('../../pages/legacy'))
const DemandesDeRappelles = lazy(() => import('../../pages/demandes/DemandesDeRappelles'))
const CoproprieteView = lazy(() => import('../../pages/copropriete'))
const AppelEntrant = lazy(() => import('../../pages/appelEntrant'))
const Devis = lazy(() => import('../../pages/public/test/devis'))
const Rh = lazy(() => import('../../pages/rh'))
const Charts = lazy(() => import('../../pages/charts'))
const AccueilView = lazy(() => import('../../pages/accueil'))
const LoginView = lazy(() => import('../../pages/login'))
const MailsView = lazy(() => import('../../pages/mails'))
const RarView = lazy(() => import('../../pages/rar'))

const Router = () => {
  const { user } = useAuth()

  return (
    <ReactRouter>
      <Switch>
        <Route path="/public/test/devis">
          <Suspense fallback={<Spinner />}>
            <Devis />
          </Suspense>
        </Route>
        <Route path="/login">
          <Suspense fallback={<Spinner />}>
            <LoginView />
          </Suspense>
        </Route>
        {/* private routes */}
        <Suspense fallback={<Spinner />}>
          <Layout>
            <Suspense fallback={<Spinner />}>
              <PrivateRoute exact path="/legacy/*">
                <Legacy />
              </PrivateRoute>
              <PrivateRoute exact={false} path="/copropriete">
                <CoproprieteView />
              </PrivateRoute>
              <PrivateRoute path="/appelEntrant">
                <AppelEntrant />
              </PrivateRoute>
              <PrivateRoute exact={false} path="/rar">
                <RarView />
              </PrivateRoute>
              <PrivateRoute path="/mails">
                <MailsView />
              </PrivateRoute>
              <PrivateRoute path="/rh">
                <Rh />
              </PrivateRoute>
              <PrivateRoute path="/charts">
                <Charts />
              </PrivateRoute>
              <PrivateRoute path="/demandes/rappels">
                <DemandesDeRappelles />
              </PrivateRoute>
              <PrivateRoute path="/notes">
                <Notes />
              </PrivateRoute>
              <PrivateRoute exact path="/">
                <AccueilView />
              </PrivateRoute>
            </Suspense>
          </Layout>
        </Suspense>
        <Redirect to={`${user ? '/' : '/login'}`} />
      </Switch>
      <DemandeDeRappel />
      <DemandeExpress />
      {/* Quand une demande est ouverte eg: https://...?demandeId=12345 */}
      <DemandeDrawer />
    </ReactRouter>
  )
}

export default Router
